// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import PDFPrintSettings from "@bg/App/Components/MyCustomQuotes/PDFPrintSettings";
import { CustomAppState } from "@bg/App/Store/Reducers";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: CustomAppState) => ({
    customQuote: state.myCustomQuoteDetails.quote,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const MyCustomQuoteDetailsPdfSettings: React.FC<Props> = ({ customQuote }) => {
    if (!customQuote) {
        return null;
    }
    return <PDFPrintSettings quote={customQuote} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(MyCustomQuoteDetailsPdfSettings),
    definition: {
        group: "Custom Quote Details" as any,
        displayName: "PDF Settings",
        icon: "Printer",
        allowedContexts: ["MyCustomQuoteDetailsPage" as any],
    },
};

export default widgetModule;
